import { Component, AfterContentInit, OnDestroy, ViewChild, OnInit, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { FormConfig } from '../../components/forms/form.objects';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { Observable, forkJoin, of, throwError } from 'rxjs';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { ProcurementProjectDTO } from '../../api/plyca-dtos-v2';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { UIService } from '../../ui.service';
import { PropertyService } from '../../properties/property.service';
import { MasterDataDTO, deNormalizaDossierId, normalizaDossierId } from '../../api/plyca-dtos';
import { Configuration } from '../../conf/app.constants';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { MenuItem } from 'primeng-lts/api/menuitem';


// DTO Auxiliar
export class CategoryAndCPVsSDADTO {
  categoryLabel: string;
  categoryIdentifier: number;
  cpvLabel: string;
  cpvIdentifier: string;
  newspecificContractEnabled: boolean;
  validDate: Date;
}


// Bean de la pantalla.
export class DynamicPurchasingSystemModelDTO {
  dossierId: string;
  dynamicPurchasingSystem: ProcurementProjectDTO; // SDA
  filterState: MasterDataDTO; // Estado del contrato basado
  startYear: number;
  filterCategory: number;
  filterCpv: string;
  filterYear: number;
  isModeEdition: boolean;
  specificContractAccumulatedExpense: number;
  yearsList: any[];
  cpvsList: any[];
  categoryList: any []; // Lista de categorías (lista de lotes)

  filterCategoryCPVsSDAList: CategoryAndCPVsSDADTO[] = []; // Categorias y CPVs del SDA. Primera pestaña de la tabla.
  filterCSDAList: any[] = []; // Lista de CSDA. Segunda pestaña de la tabla.

  csdaAccumulatedExpense: number;

}

@Component({
  selector: 'dynamicPurchasingSystemAYMAD',
  templateUrl: 'dynamicPurchasingSystemAYMAD.template.html',
  providers: [DialogService]
})



export class DynamicPurchasingSystemAYMADComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfig1: FormConfig;
  // public filterModel: any;
  loaded = true;

  specificContract: ProcurementProjectDTO; // CSDA. Si se abre desde un CSDA, tiene que mostar su SDA. La cabecera, debe ser del CSDA

  // Lista Auxiliar
  categoryCPVsSDAList: any[] = []; // Adjudicaciones del Acuerdo Marco
  csdaList: any[] = []; // Lista de Basados
  stateProperty: string;
  newspecificContractEnabled: boolean;

  // Propiedades
  propertyEstadosCB: any;
  propertyEstadosCBAdjudicados: any;

  // Varibles para los parametros de consulta de los atributos
  paramsAttributeDossierId: string;

  // Modelo de la pantalla
  model: DynamicPurchasingSystemModelDTO;
  dynamicSystemIdentifier: string;
  new = false;
  initialState: MasterDataDTO;
  constructor(
    public plycaService: PlycaDataService,
    private router: Router,
    private elem: ElementRef,
    private uiService: UIService,
    private propertyService: PropertyService,
    public configuration: Configuration,
    public dialogService: DialogService,
    public waitService: WaitLoadingService,
    public headerActionsService: HeaderActionsService,
    public activatedRoute: ActivatedRoute,
    public plycaErrorHandler: PlycaErrorHandler,
    private translateService: TranslateService,
    private location: Location,
  ) {
    super();
    this.subscribe(this.activatedRoute.params, params => {
      this.dynamicSystemIdentifier = params['id'];
      if (params['mode'] !== undefined) {
        this.new = true;
      }
      this.paramsAttributeDossierId = 'PROPUESTAID=' + this.dynamicSystemIdentifier;
      this.subscribe(
        forkJoin([
          this.propertyService.getProperty('ESTADOS_CSDA_ADJUDICADOS', '')
            .pipe(catchError((error: any) => {
              console.log(error)
              return of(undefined)
            })),
          this.plycaService.getMasterDataValues(
            'EXPESTADO', '72', undefined, 'expansionSet:COMPLETE'
          ).pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        ]),
        ([resultPropertyEstados, resultMasterData]) => {
          if (resultPropertyEstados) {
            this.stateProperty = resultPropertyEstados;
          }
          if (resultMasterData?.content) {
            this.initialState = resultMasterData?.content?.[0];
          }
        },
        error => {
          this.plycaErrorHandler.showServerError(error)
        });
      this.setModel();
    })
  }

  initHeaderInfo() {
    if (!this.model.isModeEdition) {
      this.headerActionsService.setTaskDescription(
        this.elem,
        'Situación del Sistema Dinámico de Adquisición y sus Contratos Específicos',
        'fa-file-contract',
        this.isLoaded.bind(this)
      );
      let project: ProcurementProjectDTO;
      if (this.specificContract) {
        project = this.specificContract;
      } else {
        project = this.model.dynamicPurchasingSystem;
      }
      this.headerActionsService.setProject(this.elem, project, false);
    } else {
      this.headerActionsService.setTaskDescription(
        this.elem,
        'Situación del Sistema Dinámico de Adquisición y sus Contratos Específicos', 'fa-file-contract',
        this.isLoaded.bind(this));
    }
  }

  ngOnInit(): void {
  }

  loadFunctions(_formConfig: FormConfig) {

    _formConfig.functions.push({
      identifier: 'setValueParamsAttr_SDA',
      fn: this.setValueParamsAttr_SDA.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'filterLists',
      fn: this.filterLists.bind(this)
    });
  }


  setModel() {
    this.model = new DynamicPurchasingSystemModelDTO();
    this.model.dynamicPurchasingSystem = new ProcurementProjectDTO();
    // No tenemos identificador. Hay que seleccionar el SDA.
    if (this.dynamicSystemIdentifier === undefined) {
      this.newspecificContractEnabled = true;
      this.subscribe(this.createFormConfig1(),
        (form1: FormConfig) => {
          this.model.isModeEdition = true;
          this.loadFunctions(form1);
          this.formConfig1 = form1;
        })
    } else {
      // Tenemos identificador. Se precarga el SDA
      if (this.new) {
        this.newspecificContractEnabled = true;
        this.model.isModeEdition = true;
      } else {
        this.newspecificContractEnabled = false;
        this.model.isModeEdition = false;
      }
      this.waitService.startWaiting();
      let expansionDossier = '?expand=expansionSet:subclass_complete';
      this.subscribe(
        this.plycaService.getProcurementProject(
          this.dynamicSystemIdentifier, expansionDossier
        ).pipe(
          switchMap(
            result => {
              let isCSDA = (result?.classification?.complementarySystem?.identifier === 'CSDA<>SISTCOMPLEMENTARIO');
              if (isCSDA) {
                this.specificContract = result;
                this.dynamicSystemIdentifier = deNormalizaDossierId(result?.contractingSystem?.originalContractingSystemID?.identifier);
                return this.plycaService.getProcurementProject(this.dynamicSystemIdentifier, expansionDossier);
              } else {
                return of(result);
              }
            }
          ),
          tap(result => {
            this.model = new DynamicPurchasingSystemModelDTO();
            this.model.dynamicPurchasingSystem = result;
            this.paramsAttributeDossierId = 'PROPUESTAID=' + result.identifier;
            this.model.dossierId = normalizaDossierId(this.model.dynamicPurchasingSystem.identifier);
          }
          ),
          catchError(
            (err: any) => {
              this.plycaErrorHandler.showServerError(err);
              return throwError(err);
            }
          ),
          finalize(() => {
            this.initHeaderInfo();
            this.subscribe(this.createFormConfig1().pipe(
              tap((form1: FormConfig) => {
                this.loadFunctions(form1);
                this.formConfig1 = form1;
                this.searchAll();
                this.waitService.cancelWaiting();
              })
            )
            );
          })
        ))
    }
  }


  private createFormConfig1(): Observable<FormConfig> {
    return of(new FormConfig(undefined,
      'dynamicPurchasingSystemSituation/dynamicPurchasingSystemSituation.json',
      this.model
    ));

  }


  ngAfterContentInit(): void {
    this.loaded = true;
    this.initHeaderInfo();
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), success => {
      this.uiService.routeBack();
    });
  }

  ngOnDestroy() {

    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }



  private openNewspecificContract(row: any) {
    this.router.navigate(['/dossierInfo/' + this.dynamicSystemIdentifier]);
    let ruta = 'procurementProjectAYMAD/';
    let setDefinitionIdentifier = 'FE_CSDA_AYMAD';
    let selectedCategory = row.categoryIdentifier;
    let selectedCPV = row.cpvIdentifier;
    this.router.navigate([ruta],
    {
      queryParams: {
        formid: setDefinitionIdentifier, isModel: 'false', isSpecificContract: 'true',
        dynamicPurchasingSystemParent: this.dynamicSystemIdentifier,
        categorySelectedSDA: selectedCategory,
        cpvSelectedSDA: selectedCPV
      }
    });
      /*{
        queryParams: {
          formid: setDefinitionIdentifier, isModel: 'false', isspecificContract: 'true',
          frameworkAgreementParent: this.dynamicSystemIdentifier,
        }
      });*/
  }

  public createspecificContract(row: any): void {
    this.openNewspecificContract(row);
  }

  searchAll() {
    this.subscribe(
      forkJoin([
        this.plycaService.getProcurementProject(this.dynamicSystemIdentifier, '?expand=expansionSet:EXPANDLOTS_SDA')
        .pipe(catchError((error: any) => {
          return of(undefined)
        })),
        this.plycaService.getAttributeValue(
          'SITUACION_LISTA_CSDA',
          this.paramsAttributeDossierId
        ).pipe(catchError((error: any) => {
          return of(undefined)
        }))
      ]),
      ([dynamicPurchasingSystem, resultCSDA]) => {
        if (dynamicPurchasingSystem) {
          // comprobar si hay lotes
          if (dynamicPurchasingSystem) {
            this.model.dynamicPurchasingSystem = dynamicPurchasingSystem;
            this.model.dossierId = normalizaDossierId(this.model.dynamicPurchasingSystem.identifier);
          }
          this.setYears();
          this.setCategoriesAndCPVs();
          this.categoryCPVsSDAList = this.model.filterCategoryCPVsSDAList;
        }
        if (resultCSDA) {
          if (resultCSDA && resultCSDA.values && resultCSDA.values.length > 0) {
            this.model.filterCSDAList = resultCSDA.values;
          } else {
            this.model.filterCSDAList = []
          }
          this.csdaList = this.model.filterCSDAList;
          if (this.initialState) {
            this.model.filterState = this.initialState;
          }
        }
        this.loaded = true;
        this.filterLists();
      },
      error => {
        this.plycaErrorHandler.showServerError(error)
      });
  }


  public setYears() {
    this.model.yearsList = [];
    if (this.model.dynamicPurchasingSystem) {
      let startYear = this.model.dynamicPurchasingSystem.startYear;
      let today = new Date();
      let actualYear = today.getFullYear();
      while (startYear <= actualYear) {
        this.model.yearsList.push({ label: startYear + '', value: startYear + '' });
        startYear++;
      }
    }
  }

  public setCategoriesAndCPVs() {
    this.setCPVs();
    this.setCategories();
    this.model.filterCategoryCPVsSDAList = [];
    if (this.model.dynamicPurchasingSystem !== undefined) {
      if (this.model.dynamicPurchasingSystem.breakdownLot.apportioned !== undefined
        && this.model.dynamicPurchasingSystem.breakdownLot.apportioned) {
          // SDA CON CATEGORIAS (lotes)
          let dynamicPurchasingSystemCategories =  this.model.dynamicPurchasingSystem.breakdownLot.lots;
          if (dynamicPurchasingSystemCategories !== undefined && dynamicPurchasingSystemCategories.length > 0) {
            dynamicPurchasingSystemCategories.forEach(category => {
            let aux: any;
            aux = category;
            let categoryLabel = category.lotNumber + '';
            let categoryIdentifier = category.lotId;
            if (category.cpvs !== undefined && category.cpvs.length > 0) {
              category.cpvs.forEach(cpv => {
                let elem = new CategoryAndCPVsSDADTO();
                let cpvLabel = cpv.identifier + ' - ' + cpv.description;
                elem.categoryLabel = categoryLabel;
                elem.categoryIdentifier = categoryIdentifier;
                elem.cpvLabel = cpvLabel;
                elem.cpvIdentifier = cpv.identifier;
                if (aux && aux.contractingSystem && aux.contractingSystem.frameworkAgreementValidityDate !== undefined) {
                  let validDate = aux.contractingSystem.frameworkAgreementValidityDate;
                  let currentDate = new Date();
                  if (validDate >= currentDate) {
                    elem.validDate = validDate;
                    this.model.filterCategoryCPVsSDAList.push(elem);
                  }
                }
              });
            }
          });
        }
        } else {
          // SDA SIN CATEGORIAS (lotes)
          let category = '';
          let dynamicPurchasingSystemCPVs =  this.model.dynamicPurchasingSystem.breakdownLot.totalLots.cpvs;
          let aux: any;
          aux = this.model.dynamicPurchasingSystem.breakdownLot.totalLots;
            if (dynamicPurchasingSystemCPVs !== undefined && dynamicPurchasingSystemCPVs.length > 0) {
              dynamicPurchasingSystemCPVs.forEach(cpv => {
                let elem = new CategoryAndCPVsSDADTO();
                let cpvLabel = cpv.identifier + ' - ' + cpv.description;
                elem.categoryLabel = category;
                elem.cpvLabel = cpvLabel;
                elem.cpvIdentifier = cpv.identifier;
                if (aux && aux.contractingSystem && aux.contractingSystem.frameworkAgreementValidityDate !== undefined) {
                  elem.validDate = aux.contractingSystem.frameworkAgreementValidityDate;
                }
                this.model.filterCategoryCPVsSDAList.push(elem);
              });
            }
        }
    }
  }

  public setCPVs() {
    this.model.cpvsList = [];
    if (this.model.dynamicPurchasingSystem !== undefined && this.model.dynamicPurchasingSystem.breakdownLot.totalLots !== undefined) {
      let dynamicPurchasingSystemCPVs =  this.model.dynamicPurchasingSystem.breakdownLot.totalLots.cpvs;
      if (dynamicPurchasingSystemCPVs !== undefined && dynamicPurchasingSystemCPVs.length > 0) {
        dynamicPurchasingSystemCPVs.forEach(cpv => {
          let cpvLabel = cpv.identifier + ' - ' + cpv.description;
          this.model.cpvsList.push({ label: cpvLabel , value: cpv.identifier});
        });
      }
    }
  }

  public setCategories() {
    this.model.categoryList = [];
    if (this.model.dynamicPurchasingSystem !== undefined && this.model.dynamicPurchasingSystem.breakdownLot.apportioned !== undefined
      && this.model.dynamicPurchasingSystem.breakdownLot.apportioned) {
      let dynamicPurchasingSystemCategories =  this.model.dynamicPurchasingSystem.breakdownLot.lots;
      if (dynamicPurchasingSystemCategories !== undefined && dynamicPurchasingSystemCategories.length > 0) {
        dynamicPurchasingSystemCategories.forEach(category => {
          let aux: any;
          aux = category;
          if (aux && aux.contractingSystem && aux.contractingSystem.frameworkAgreementValidityDate !== undefined) {
            let validDate = aux.contractingSystem.frameworkAgreementValidityDate;
            let currentDate = new Date();
            if (validDate >= currentDate) {
              this.model.categoryList.push({ label: category.lotNumber + ' - ' + category.description, value: category.lotId});
            }
          }
        });
      }
    }
  }


  public setValueParamsAttr_SDA(model: any) {
    this.model.filterCSDAList = [];
    if (model && model.dynamicPurchasingSystem && model.dynamicPurchasingSystem.identifier) {
      this.dynamicSystemIdentifier = deNormalizaDossierId(model.dynamicPurchasingSystem.identifier);
      this.paramsAttributeDossierId = 'PROPUESTAID=' + this.dynamicSystemIdentifier;
      this.searchAll();
    } else {
      this.paramsAttributeDossierId = '';
      this.model.yearsList = [];
      this.model.categoryList = [];
      this.model.filterCategory = undefined;
      this.model.cpvsList = [];
      this.model.filterCpv = undefined;
      this.filterLists();
    }
    let identifier = deNormalizaDossierId(this.dynamicSystemIdentifier);
    let url = "dynamicPurchasingSystemAYMAD/" + identifier + "/reload";
    this.location.replaceState(url);
  }


  public filterLists() {
    // Si no hay filtros, mostramos la lista completa.
    if (!this.model.filterCategory && !this.model.filterYear && !this.model.filterState && !this.model.filterCpv) {
      this.model.filterCategoryCPVsSDAList = this.categoryCPVsSDAList;
      this.model.filterCSDAList = this.csdaList;
    } else {
      let auxFilterCategoryCPVsSDAList = this.categoryCPVsSDAList;
      let auxFilterCSDAList = this.csdaList;

      // 1. Categoria: Filtramos las dos listas
      if (this.model.filterCategory) {
        auxFilterCategoryCPVsSDAList = auxFilterCategoryCPVsSDAList
          .filter(sdaCategory => sdaCategory.categoryIdentifier === this.model.filterCategory);

          auxFilterCSDAList = auxFilterCSDAList
          .filter(csda =>
            (csda?.columns['CATEGORIA_ID_CSDA']?.value === String(this.model.filterCategory)));
      }

      // 2. Categoria: Filtramos las dos listas
      if (this.model.filterCpv) {
        auxFilterCategoryCPVsSDAList = auxFilterCategoryCPVsSDAList
        .filter(sdaCVP => sdaCVP.cpvIdentifier === this.model.filterCpv);


        auxFilterCSDAList = auxFilterCSDAList
        .filter(csda =>
          (csda?.columns['CPVID_CSDA']?.value === this.model.filterCpv));
      }

      // 2. Año. Filtramos solo los csda
      if (this.model?.filterYear) {
        auxFilterCSDAList = auxFilterCSDAList
        .filter(csda =>
          (csda?.columns['ANOINICIO']?.value === String(this.model.filterYear)));
      }



      let auxStates = this.stateProperty.split(';');

      let csdaAccumulatedExpenseList = auxFilterCSDAList.filter(csda => {
        let stateId = csda?.columns['TIPOESTADOID']?.value;

        let stateExists = false;

        auxStates.forEach(auxState => {
          if (stateId !== undefined && auxState === stateId.toString()) {
            // console.log('ESTADO DEL BASADO: ' + desc + ': ' + stateId)
            // console.log('ESTADO CORRECTO: comparando ESTADO DEL BASADO: ' + stateId + 'con el estado: ' + auxState);
            stateExists = true;
          }
        });

        return stateExists;
      });

      // console.log('VECTOR FINAL: ' + basedContractAccumulatedExpenseList.length);
      let total = 0.0;
      csdaAccumulatedExpenseList.forEach(csda => {
        if (csda?.columns['PRECIO']?.value) {
          total += this.roundDecimals(Number(csda?.columns['PRECIO'].value));
        }
      })
      this.model.csdaAccumulatedExpense = total;



      // 3. Filtramos por los valores de la propiedad ESTADOS_CB_ADJUDICADOS. Primer filtro por la lógica complicada.
      if (this.model.filterState && this.model.filterState.identifier) {
        let filterState = this.model?.filterState?.identifier.substring(0, this.model?.filterState?.identifier?.indexOf('<>'));
        if (filterState === '72') {
          // tslint:disable-next-line: max-line-length
          // Si el estado es adjudicado, tiene que filtar por los estados definidos en la propiedad ESTADOS_CSDA_ADJUDICADOS que se consulta al crear el formulario.
          let otherStatesCSDAList: any[] = [];
          // tslint:disable-next-line:no-shadowed-variable
          let auxStates = this.stateProperty.split(';');
          auxStates.forEach(state => {
            let aux = auxFilterCSDAList
              .filter(csda => csda?.columns['TIPOESTADOID']?.value === state);
            aux.forEach(csda => otherStatesCSDAList.push(csda));
            aux = [];
          });
          auxFilterCSDAList = otherStatesCSDAList;
        } else {
          auxFilterCSDAList = auxFilterCSDAList
          .filter(csda =>
            (csda?.columns['TIPOESTADOID']?.value === filterState));
        }
      }


      // Actualizamos las listas que se muestran
      this.model.filterCategoryCPVsSDAList = auxFilterCategoryCPVsSDAList;
      this.model.filterCSDAList = auxFilterCSDAList;

      if (this.model.filterCategoryCPVsSDAList.length > 0) {
        this.model.filterCategoryCPVsSDAList.forEach(element => {
          element.newspecificContractEnabled = this.newspecificContractEnabled;
        });
      }
    }
  }



  addLink(items: MenuItem[], identifier: string, description: string, icon: string, componentName: string) {
    let mn: MenuItem = {};
    this.subscribe(
      this.translateService.get(description), ((res: string) => {
        mn.label = res;
      }));
    mn.icon = icon;
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: componentName };
    items.push(mn);

  }

  public getDossierMenuItemAM(identifier: any): MenuItem[] {
    identifier = deNormalizaDossierId(identifier);
    let items: MenuItem[] = [];
    this.addLink(items, identifier, 'DossierInfo.sections.GENERAL_INFO.short', 'fa fa-info-circle', 'GENERAL_INFO');
    this.addLink(items, identifier, 'DossierInfo.sections.DOSSIER_ACTIONS.short', 'fa fa-tasks', 'DOSSIER_ACTIONS');
    this.addLink(items, identifier, 'DossierInfo.sections.CONTRACTS.short', 'fa fa-file-contract', 'CONTRACTSAYMAD');
    this.addLink(items, identifier, 'DossierInfo.sections.DOCUMENTS.short', 'fa fa-file-alt', 'DOCUMENTS');
    this.addLink(items, identifier, 'DossierInfo.sections.ACCOUNTING.short', 'fa fa-euro-sign', 'ACCOUNTING');
    this.addLink(items, identifier, 'DossierInfo.sections.PROCEDURES.short', 'fa fa-list-ul', 'PROCEDURES');
    this.addLink(items, identifier, 'DossierInfo.sections.AUDIT.short', 'fa fa-lg fa-list-ul', 'AUDIT');


    return items;
  }

  public getDossierMenuItemCBAM(identifier: any): MenuItem[] {
    identifier = deNormalizaDossierId(identifier);
    let items: MenuItem[] = [];
    this.addLink(items, identifier, 'DossierInfo.sections.GENERAL_INFO.short', 'fa fa-info-circle', 'GENERAL_INFO');
    this.addLink(items, identifier, 'DossierInfo.sections.DOSSIER_ACTIONS.short', 'fa fa-tasks', 'DOSSIER_ACTIONS');
    this.addLink(items, identifier, 'DossierInfo.sections.CONTRACTS.short', 'fa fa-file-contract', 'CONTRACTSAYMAD');
    this.addLink(items, identifier, 'DossierInfo.sections.DOCUMENTS.short', 'fa fa-file-alt', 'DOCUMENTS');
    this.addLink(items, identifier, 'DossierInfo.sections.ACCOUNTING.short', 'fa fa-euro-sign', 'ACCOUNTING');
    this.addLink(items, identifier, 'DossierInfo.sections.PROCEDURES.short', 'fa fa-list-ul', 'PROCEDURES');
    this.addLink(items, identifier, 'DossierInfo.sections.AUDIT.short', 'fa fa-lg fa-list-ul', 'AUDIT');


    return items;
  }

  private roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals === 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  deNormalizaDossierId(dossierId: string) {
    return deNormalizaDossierId(dossierId);
  }

  openDossier(dossier) {
    let dossierAux = '';
    if (dossier !== undefined && dossier !== '') {
      dossierAux = deNormalizaDossierId(dossier);
    } else {
      dossierAux = this.dynamicSystemIdentifier;
    }
    this.router.navigate(['/dossierInfo/' + dossierAux]);
  }



}
